@charset "UTF-8";
.rjsf .form-group {
  margin-bottom: 1rem;
}
.rjsf label {
  display: inline-block;
  margin-bottom: 0.5rem;
  font-weight: 500;
}
.rjsf .form-control {
  display: block;
  width: 100%;
  padding: 0.5rem 1rem;
  box-sizing: border-box;
}
.rjsf .field-description {
  opacity: 0.65;
  margin-bottom: 1rem;
}
.rjsf .form-group.field-array {
  padding: 1rem;
  background: rgba(255, 255, 255, 0.0666666667);
}
.rjsf .form-group.field-array.multi-select-array {
  padding: 0;
}
.rjsf .form-group.field-array .row {
  padding: 1rem;
  background: rgba(255, 255, 255, 0.0666666667);
}
.rjsf .form-group.field-array .row:empty {
  display: none;
}
.rjsf .form-group.field-array .array-item {
  display: flex;
}
.rjsf .form-group.field-array .array-item:not(:last-child) {
  margin-bottom: 2rem;
}
.rjsf .form-group.field-array .array-item > *:first-child {
  flex: 1 1 100%;
}
.rjsf .form-group.field-array .array-item-toolbox {
  flex: 0 1 15rem;
  margin-left: 2rem;
}
.rjsf .form-group.field-array .btn-add {
  margin-left: auto;
  width: 15rem;
}
.rjsf legend {
  font-weight: 500;
  text-transform: capitalize;
  font-size: 1.2rem;
  margin-bottom: 1rem;
}
.rjsf .btn {
  box-sizing: border-box;
}
.rjsf .btn.btn-add::before {
  content: "+";
}
.rjsf .btn.array-item-remove::before {
  content: "-";
}
.rjsf .btn.array-item-move-up::before {
  content: "⬆";
}
.rjsf .btn.array-item-move-down::before {
  content: "⬇";
}

.light-theme .rjsf .form-group.field-array {
  border: 1px solid #cccccc;
}
.light-theme .rjsf .form-group.field-array .row {
  border: 1px solid #cccccc;
}
.light-theme .rjsf .form-group.field-array.multi-select-array {
  border: none;
  background: none;
}
.light-theme .rjsf .form-group.field-array.multi-select-array .row {
  border: none;
}

.dark-theme .rjsf .form-group.field-array {
  border: 1px solid rgb(30%, 30%, 30%);
}
.dark-theme .rjsf .form-group.field-array .row {
  border: 1px solid rgb(30%, 30%, 30%);
}
.dark-theme .rjsf .form-group.field-array.multi-select-array {
  border: none;
  background: none;
}
.dark-theme .rjsf .form-group.field-array.multi-select-array .row {
  border: none;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9zcmMvc2NyaXB0L2NvbXBvbmVudHMvU2l0ZUFkbWluVmlldy9MYXlvdXRWaWV3Iiwic291cmNlcyI6WyJGb3Jtcy5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFHRTtFQUNFOztBQUdGO0VBQ0U7RUFDQTtFQUNBOztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7O0FBR0Y7RUFDRTtFQUNBOztBQUdGO0VBQ0U7RUFDQTs7QUFFQTtFQUNFOztBQUdGO0VBQ0U7RUFDQTs7QUFFQTtFQUNFOztBQUlKO0VBQ0U7O0FBRUE7RUFDRTs7QUFHRjtFQUNFOztBQUlKO0VBQ0U7RUFDQTs7QUFHRjtFQUNFO0VBQ0E7O0FBSUo7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7QUFHRjtFQUNFOztBQUdFO0VBQ0U7O0FBS0Y7RUFDRTs7QUFLRjtFQUNFOztBQUtGO0VBQ0U7OztBQVFKO0VBQ0U7O0FBRUE7RUFDRTs7QUFHRjtFQUNFO0VBQ0E7O0FBRUE7RUFDRTs7O0FBU047RUFDRTs7QUFFQTtFQUNFOztBQUdGO0VBQ0U7RUFDQTs7QUFFQTtFQUNFIiwic291cmNlc0NvbnRlbnQiOlsiQHVzZSAnQGlxL3JlYWN0LWNvbXBvbmVudHMvZGlzdC9jb2xvcnMuc2NzcycgYXMgY29sb3JzO1xuXG4ucmpzZiB7XG4gIC5mb3JtLWdyb3VwIHtcbiAgICBtYXJnaW4tYm90dG9tOiAxcmVtO1xuICB9XG5cbiAgbGFiZWwge1xuICAgIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgICBtYXJnaW4tYm90dG9tOiAwLjVyZW07XG4gICAgZm9udC13ZWlnaHQ6IDUwMDtcbiAgfVxuXG4gIC5mb3JtLWNvbnRyb2wge1xuICAgIGRpc3BsYXk6IGJsb2NrO1xuICAgIHdpZHRoOiAxMDAlO1xuICAgIHBhZGRpbmc6IDAuNXJlbSAxcmVtO1xuICAgIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gIH1cblxuICAuZmllbGQtZGVzY3JpcHRpb24ge1xuICAgIG9wYWNpdHk6IDAuNjU7XG4gICAgbWFyZ2luLWJvdHRvbTogMXJlbTtcbiAgfVxuXG4gIC5mb3JtLWdyb3VwLmZpZWxkLWFycmF5IHtcbiAgICBwYWRkaW5nOiAxcmVtO1xuICAgIGJhY2tncm91bmQ6ICNmZmZmZmYxMTtcblxuICAgICYubXVsdGktc2VsZWN0LWFycmF5IHtcbiAgICAgIHBhZGRpbmc6IDA7XG4gICAgfVxuXG4gICAgLnJvdyB7XG4gICAgICBwYWRkaW5nOiAxcmVtO1xuICAgICAgYmFja2dyb3VuZDogI2ZmZmZmZjExO1xuXG4gICAgICAmOmVtcHR5IHtcbiAgICAgICAgZGlzcGxheTogbm9uZTtcbiAgICAgIH1cbiAgICB9XG5cbiAgICAuYXJyYXktaXRlbSB7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuXG4gICAgICAmOm5vdCg6bGFzdC1jaGlsZCkge1xuICAgICAgICBtYXJnaW4tYm90dG9tOiAycmVtO1xuICAgICAgfVxuXG4gICAgICA+ICo6Zmlyc3QtY2hpbGQge1xuICAgICAgICBmbGV4OiAxIDEgMTAwJTtcbiAgICAgIH1cbiAgICB9XG5cbiAgICAuYXJyYXktaXRlbS10b29sYm94IHtcbiAgICAgIGZsZXg6IDAgMSAxNXJlbTtcbiAgICAgIG1hcmdpbi1sZWZ0OiAycmVtO1xuICAgIH1cblxuICAgIC5idG4tYWRkIHtcbiAgICAgIG1hcmdpbi1sZWZ0OiBhdXRvO1xuICAgICAgd2lkdGg6IDE1cmVtO1xuICAgIH1cbiAgfVxuXG4gIGxlZ2VuZCB7XG4gICAgZm9udC13ZWlnaHQ6IDUwMDtcbiAgICB0ZXh0LXRyYW5zZm9ybTogY2FwaXRhbGl6ZTtcbiAgICBmb250LXNpemU6IDEuMnJlbTtcbiAgICBtYXJnaW4tYm90dG9tOiAxcmVtO1xuICB9XG5cbiAgLmJ0biB7XG4gICAgYm94LXNpemluZzogYm9yZGVyLWJveDtcblxuICAgICYuYnRuLWFkZCB7XG4gICAgICAmOjpiZWZvcmUge1xuICAgICAgICBjb250ZW50OiAnKyc7XG4gICAgICB9XG4gICAgfVxuXG4gICAgJi5hcnJheS1pdGVtLXJlbW92ZSB7XG4gICAgICAmOjpiZWZvcmUge1xuICAgICAgICBjb250ZW50OiAnLSc7XG4gICAgICB9XG4gICAgfVxuXG4gICAgJi5hcnJheS1pdGVtLW1vdmUtdXAge1xuICAgICAgJjo6YmVmb3JlIHtcbiAgICAgICAgY29udGVudDogJ+Kshic7XG4gICAgICB9XG4gICAgfVxuXG4gICAgJi5hcnJheS1pdGVtLW1vdmUtZG93biB7XG4gICAgICAmOjpiZWZvcmUge1xuICAgICAgICBjb250ZW50OiAn4qyHJztcbiAgICAgIH1cbiAgICB9XG4gIH1cbn1cblxuLmxpZ2h0LXRoZW1lIHtcbiAgLnJqc2Yge1xuICAgIC5mb3JtLWdyb3VwLmZpZWxkLWFycmF5IHtcbiAgICAgIGJvcmRlcjogMXB4IHNvbGlkIGNvbG9ycy4kR3JleTIwO1xuXG4gICAgICAucm93IHtcbiAgICAgICAgYm9yZGVyOiAxcHggc29saWQgY29sb3JzLiRHcmV5MjA7XG4gICAgICB9XG5cbiAgICAgICYubXVsdGktc2VsZWN0LWFycmF5IHtcbiAgICAgICAgYm9yZGVyOiBub25lO1xuICAgICAgICBiYWNrZ3JvdW5kOiBub25lO1xuXG4gICAgICAgIC5yb3cge1xuICAgICAgICAgIGJvcmRlcjogbm9uZTtcbiAgICAgICAgfVxuICAgICAgfVxuICAgIH1cbiAgfVxufVxuXG4uZGFyay10aGVtZSB7XG4gIC5yanNmIHtcbiAgICAuZm9ybS1ncm91cC5maWVsZC1hcnJheSB7XG4gICAgICBib3JkZXI6IDFweCBzb2xpZCBjb2xvcnMuJEdyZXk3MDtcblxuICAgICAgLnJvdyB7XG4gICAgICAgIGJvcmRlcjogMXB4IHNvbGlkIGNvbG9ycy4kR3JleTcwO1xuICAgICAgfVxuXG4gICAgICAmLm11bHRpLXNlbGVjdC1hcnJheSB7XG4gICAgICAgIGJvcmRlcjogbm9uZTtcbiAgICAgICAgYmFja2dyb3VuZDogbm9uZTtcblxuICAgICAgICAucm93IHtcbiAgICAgICAgICBib3JkZXI6IG5vbmU7XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9XG4gIH1cbn1cbiJdfQ== */